<template>
  <div style="width: 100%;height: 100%;position: relative;">
    <div class="treearrow">
      <span :class="{active:isactive == 0}" @click="showdata(0, true)">地球物理勘探</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 1}" @click="showdata(1, true)">钻井</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 2}" @click="showdata(2, true)">录井</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 3}" @click="showdata(3, true)">测井</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 4}" @click="showdata(4, true)">固井</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 5}" @click="showdata(5, true)">完井</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 6}" @click="showdata(6, true)">射孔</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 7}" @click="showdata(7, true)">采油</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 8}" @click="showdata(8, true)">修井</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 9}" @click="showdata(9, true)">增产</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 10}" @click="showdata(10, true)">油田地面工程</span>
      <img src="../assets/treearrow.png" alt="">
      <span :class="{active:isactive == 11}" @click="showdata(11, true)">海洋油气工程</span>
    </div>
    <div @click="clicknode($event)" ref="etree" id="etree" style="width: 100%;height: 100%;position: relative;padding-top: 20px">
    </div>
    <div class="scrolltwo" :style="{'display': isblock ? 'block' : 'none'}">
      <div style="float: left;width: 50%;">
        <div class="scrolltitle">
          <div class="titleline"></div><span>相关公司</span>
        </div>
        <div style="border: 1px solid #f2f2f2;background: #fff;padding: 20px;height: 500px;overflow: auto;">
          <div class="scrollbox" v-for="(com, index) in companys" :key="index">
            <div style="float: left;">{{com.title}}</div>
            <div style="float: right;">{{com.zone}}</div>
          </div>
        </div>
      </div>
      <div style="float: right;width: 50%;">
        <div class="scrolltitle">
          <div class="titleline"></div><span>专家信息</span>
        </div>
        <div style="border: 1px solid #f2f2f2;background: #fff;padding: 20px;height: 500px;overflow: auto;">
          <div class="scrollbox" v-for="(exp, index) in experts" :key="index">
            <div style="float: left;">{{exp.title}}</div>
            <div style="float: right;">{{exp.incompany}}</div>
          </div>
        </div>
      </div>
      <div @click="closebox" style="position: absolute;right: 0;top: 0;width: 30px;height:30px;"><img style="width: 100%;" src="../../static/close.png" alt=""></div>
    </div>
  </div>
</template>
<script>
import Bus from '../bus.js'
import jsmind from './jsmind.js'
import jsminddraggable from './jsmind.draggable.js'
let mind, options, jm
export default {
  data() {
    return {
      isactive: 0,
      companys: [],
      experts: [],
      isblock: false
    }
  },
  mounted() {
    this.showdata(0, false)
    this.selftree()
  },
  methods: {
    selftree() {
      const self2 = this
      setTimeout(() => {
        window.onresize = function() {
          self2.$refs.etree.resize()
        }
      }, 10)
    },
    clicknode(e) {
      var catname = '';
      switch (this.isactive) {
        case 0:
          catname = '地球物理勘探'
          break;
        case 1:
          catname = '钻井'
          break;
        case 2:
          catname = '录井'
          break;
        case 3:
          catname = '测井'
          break;
        case 4:
          catname = '固井'
          break;
        case 5:
          catname = '完井'
          break;
        case 6:
          catname = '射孔'
          break;
        case 7:
          catname = '采油'
          break;
        case 8:
          catname = '修井'
          break;
        case 9:
          catname = '增产'
          break;
        case 10:
          catname = '油田地面工程'
          break;
        case 11:
          catname = '海洋油气工程'
          break;
        default:
          ''
      }
      var data2 = {
        action: 'getlist',
        catname: catname
      }
      data2 = this.$qs.stringify(data2)
      this.$http({
        method: 'post',
        url: 'http://www.oillink.com/getographs2.php',
        data: data2
      }).then((response) => {
        // console.log(jm.get_selected_node())
        var vm = jm.get_selected_node()
        var element = e.target || event.srcElement;
        var isexpander = jm.view.is_expander(element);
        console.log(isexpander)
        if (jm.get_selected_node()&&!isexpander) {
          this.isblock = true;
        }
        this.companys = response.data.com;
        this.experts = response.data.exp;
      })
    },
    closebox() {
      this.isblock = false
    },
    showdata(num, istrue) {
      this.$refs.etree.innerHTML = '';
      this.isblock = false
      this.isactive = num;
      if (istrue) {
        Bus.$emit('changetype', num)
      }
      var data = {
        action: 'getalls'
      }
      data = this.$qs.stringify(data)
      this.$http({
        method: 'post',
        url: 'http://www.oillink.com/getographs2.php',
        data: data
      }).then((response) => {
        let data = response.data[num]
        // console.log(response.data)
        mind = {
          "meta": {
            "name": "demo",
            "author": "hizzgdev@163.com",
            "version": "0.2",
          },
          "format": "node_tree",
          "data": data
        };
        options = {
          container: 'etree',
          editable: false,
          mode: 'full',
          view: {
            hmargin: 100, // 思维导图距容器外框的最小水平距离
            vmargin: 50, // 思维导图距容器外框的最小垂直距离
            line_width: 2, // 思维导图线条的粗细
            line_color: '#00ffff' // 思维导图线条的颜色
          },
          layout: {
            hspace: 30, // 节点之间的水平间距
            vspace: 10, // 节点之间的垂直间距
            pspace: 20 // 节点与连接线之间的水平间距（用于容纳节点收缩/展开控制器）
          },
          theme: 'primary'
        }
        jm = jsMind.show(options, mind);
        // jm.get_selected_node()
        // jm.click_handle()
        // console.log(jm.click_handle())
      })
    },
    createController() {
      this.$http({
        method: 'post',
        url: 'http://www.oillink.com/getographs2.php',
      }).then((response) => {
        let data = response.data[0]
        console.log(response.data)
        var mind = {
          "meta": {
            "name": "demo",
            "author": "hizzgdev@163.com",
            "version": "0.2",
          },
          "format": "node_tree",
          "data": data
        };
        var options = {
          container: 'etree',
          editable: true,
          mode: 'full',
          view: {
            hmargin: 100, // 思维导图距容器外框的最小水平距离
            vmargin: 50, // 思维导图距容器外框的最小垂直距离
            line_width: 2, // 思维导图线条的粗细
            line_color: '#00ffff' // 思维导图线条的颜色
          },
          layout: {
            hspace: 30, // 节点之间的水平间距
            vspace: 10, // 节点之间的垂直间距
            pspace: 20 // 节点与连接线之间的水平间距（用于容纳节点收缩/展开控制器）
          },
          theme: 'primary'
        }
        var jm = jsMind.show(options, mind);
      })
    },
  }
}

</script>
<style>
@import './jsmind.css';

.treearrow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 111;
  background: #002465;
  padding: 20px 0;
}

.treearrow span {
  color: #fff;
  padding: 5px 13px;
  background-color: #428bca;
  border-radius: 5px;
  margin-right: 5px;
  font: 14px/1.125 Verdana, Arial, Helvetica, sans-serif;
  cursor: pointer;
}

.treearrow span.active {
  background-color: #f1c40f
}

.treearrow span:hover {
  background-color: #f1c40f;
}

.treearrow img {
  width: 20px;
  margin-right: 5px;
}

jmnode.root {
  font-size: 20px;
  background-color: #f1c40f !important;
}

jmnode {
  font-size: 12px;
  padding: 5px;
}

jmexpander {
  border-color: #fff;
  color: #fff;
  line-height: 8px;
}

jmexpander:hover {
  border-color: #fff;
}

::-webkit-scrollbar {
  width: 5px;
  /*对垂直流动条有效*/
  height: 5px;
  /*对水平流动条有效*/
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #E8E8E8;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  border-radius: 7px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #428bca;
}

.scrolltwo {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 15%;
  z-index: 9999;
  width: 80%;
  /*height: 80%;*/
  display: none;
  /*overflow: hidden;*/
  padding: 10px;
  border: 1px solid #d9dce1;
  background: #f6f6f6;
}

.scrollbox {
  /*width: 48%;*/
  overflow: hidden;
  white-space: normal !important;
  font-size: 10px;
  color: #4c4c4c;
  border-bottom: 1px solid #e6e6e6;
  line-height: 39px;
}

.scrolltitle {
  font-size: 11px;
  color: #4c4c4c;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.titleline {
  width: 10px;
  height: 14px;
  background: #00aaff;
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Show.vue